import { render, staticRenderFns } from "./SensitiveContentDeclined.vue?vue&type=template&id=a8fa2df0&"
import script from "./SensitiveContentDeclined.vue?vue&type=script&lang=ts&"
export * from "./SensitiveContentDeclined.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports